import { defineAnalytics } from '@zg-rentals/rentals-analytics';
import { tracker as CLICKSTREAM } from '@zg-rentals/clickstream';
import { tracker as COMSCORE } from '@zg-rentals/comscore/client';
import type { ZrmUserInfo } from '@zg-rentals/clickstream';
import type { RenterProfileOrNull } from './types';

export const analytics = defineAnalytics({ COMSCORE, CLICKSTREAM });

export const trackComscoreEvent = analytics.createTrackEvent('COMSCORE');

export const trackEvent = analytics.createTrackEvent('CLICKSTREAM');

export const trackUserEvent = analytics.createTrackEvent<'CLICKSTREAM', ZrmUserInfo>('CLICKSTREAM');

export const trackRenterProfileEvent = analytics.createTrackEvent<'CLICKSTREAM', RenterProfileOrNull>('CLICKSTREAM');

export const trackUserRenterProfileEvent = analytics.createTrackEvent<'CLICKSTREAM', ZrmUserInfo & RenterProfileOrNull>(
  'CLICKSTREAM',
);
